// Shared helper for the admin login "Beni Hatırla" behavior, used by both admin login
// entry points (the full /yonetim/giris page AND the hero/footer modal trigger). "Beni
// Hatırla" means SADECE username is remembered - the password is never written to
// localStorage or any other persistent store, in either entry point.
export const ADMIN_REMEMBERED_USERNAME_KEY = "karsli_admin_remembered_username";

export const readRememberedAdminUsername = () => {
  try {
    return localStorage.getItem(ADMIN_REMEMBERED_USERNAME_KEY) || "";
  } catch {
    // localStorage kullanılamıyorsa (gizli sekme, devre dışı vb.) sessizce yoksay.
    return "";
  }
};

/** Login başarılı olduktan sonra çağrılır - checkbox durumuna göre SADECE username'i
 * kalıcı depoya yazar veya oradan kaldırır. Şifre bu fonksiyona hiç parametre olarak
 * bile verilmez. */
export const persistRememberedAdminUsername = (rememberMe, username) => {
  try {
    if (rememberMe && username) {
      localStorage.setItem(ADMIN_REMEMBERED_USERNAME_KEY, username);
    } else {
      localStorage.removeItem(ADMIN_REMEMBERED_USERNAME_KEY);
    }
  } catch {
    // localStorage kullanılamıyorsa sessizce yoksay - login akışını bloklamaz.
  }
};
